import React from 'react';
import {SVGProps} from '~/src/components/svg/SVGProps';

const NavVideo = ({primaryClassName, secondaryClassName, tertiaryClassName}: SVGProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path className={tertiaryClassName} d="M9 23.64v2.23l5.55-3.71-1.1-1.66L9 23.64z" />
        <path className={secondaryClassName} d="M12.45 10.83L20.2 16l-6.75 4.5 1.1 1.66L23.8 16 13.55 9.17l-1.1 1.66z" />
        <path className={primaryClassName} d="M11 9.87l1.45.96 1.1-1.66L9 6.13v15.02l2-1.47V9.87z" />
    </svg>
);

export default NavVideo;
